import React from "react";
import { Schema } from "@comparaonline/products-schema";

import { useAppContext } from "../../../../../../lib/appContext";
import { submitReview } from "./submitReview";
import { Form, FormProps } from "./Form";
import { Container } from "./Container";
import { ErrorMessage } from "./ErrorMessage";
import { CreateProductReviewMutation } from "../../../../../../queries/reviews/components/CreateProductReviewMutation";

export interface FormStepProps extends FormProps {
  onSubmit: () => void;
  product: Schema.ProductListProduct;
}

export const FormStep: React.FC<FormStepProps> = ({ onCancel, onSubmit, product }) => {
  const { businessUnitConfig } = useAppContext();
  return (
    <CreateProductReviewMutation>
      {(submitFn, { data, loading, error }) => {
        if (error || (!loading && !!data)) {
          return <ErrorMessage />;
        }
        return (
          <Container isLoading={loading}>
            <Form
              onCancel={onCancel}
              onSubmit={submitReview(submitFn, product, businessUnitConfig.businessCode, onSubmit)}
              businessUnitName={businessUnitConfig.name}
            />
          </Container>
        );
      }}
    </CreateProductReviewMutation>
  );
};
